export const ACCESS_TOKEN_KEY = 'access_token';
export const REFRESH_TOKEN_KEY = 'refresh_token';

export const ACCOUNT_KEY = 'api-account';

// Deprecated
export const JWT_KEY = 'api-jwt';
